"use client";

import * as React from "react";

/**
 * A callback ref that runs `measure` on mount and on every resize of the
 * element. The observer is rebuilt when the DOM node changes identity, so it
 * never keeps watching a detached element.
 */
export function useResizeMeasurement<E extends Element>(
  measure: (el: E) => void,
): (el: E | null) => void {
  const observerRef = React.useRef<ResizeObserver | null>(null);

  return React.useCallback(
    (el: E | null) => {
      observerRef.current?.disconnect();
      if (!el) {
        observerRef.current = null;
        return;
      }
      measure(el);
      const observer = new ResizeObserver(() => measure(el));
      observer.observe(el);
      observerRef.current = observer;
    },
    [measure],
  );
}
